import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { UPDATE_LANGUAGES_ASYNC } from 'containers/Settings/Languages/constants'

import {
  getLandingPagesError,
  getLandingPagesSuccess,
  updLandingPagesError,
  updLandingPagesSuccess,
} from './actions'
import { LANDING_FROM_REQUEST_ASYNC, LANDING_FROM_UPDATE_ASYNC } from './constants'

const getLandingPagesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      LANDING_FROM_REQUEST_ASYNC.INITIATE,
      LANDING_FROM_UPDATE_ASYNC.SUCCESS,
      UPDATE_LANGUAGES_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.impersonation)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getSightsLandingPages(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getLandingPagesSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getLandingPagesError, error)))
        .takeUntil(action$.ofType(LANDING_FROM_REQUEST_ASYNC.CANCEL))
    )

const updLandingPagesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(LANDING_FROM_UPDATE_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updateSightsLandingPages(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().settings.mailboxProtection.landings.data
      )
      .map((response) => updLandingPagesSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updLandingPagesError, error)))
      .takeUntil(action$.ofType(LANDING_FROM_UPDATE_ASYNC.CANCEL))
  )

export default combineEpics(getLandingPagesEpic, updLandingPagesEpic)
